import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Navbar from '../components/navbar';
import { CaseStudy,BusinessOverView,Expertise,ProjectDetails } from '../pages';
import ScrollToTopButton from '../components/scrollButton';
import WhatsAppIcon from '../components/watsappIcon';
import Footer from '../components/footer';
import NotFound from '../pages/notFound';
import { InfoProvider } from "../utiles/InfoContext";
const AllRoutes = () => {
  return (
    <BrowserRouter>
      <InfoProvider>
      <Navbar />
      <Routes>
        <Route path="/" element={<BusinessOverView />} />  
        <Route path="/busniess-overview" element={<BusinessOverView />} />  

        <Route path="/case-studies" element={<CaseStudy />} />
        <Route path="/my-expertise" element={<Expertise />} />
        <Route path="/case-studies/:id" element={<ProjectDetails />} />
        <Route path="*" element={<NotFound />} />

      </Routes>
      </InfoProvider>
      <ScrollToTopButton />
      <WhatsAppIcon/>
      <Footer/>
    </BrowserRouter>
  );
};

export default AllRoutes;
